import React, {useEffect, useState} from "react";

import './MainPage.css'
import backgroundImage from "asset/video/parplay_3bit.mp4";
import perplayInfoKo from "asset/image/perplay_info_pc_ko(MATIC).png";
import perplayInfoEn from "asset/image/perplay_info_pc_en(MATIC).png";

import perplayRevealInfoKo from "asset/image/20230420_close_kr_1152px.png";
import perplayRevealInfoEn from "asset/image/20230420_close_en_1152px.png";

import externalTitle from "asset/image/external/external market.png";
import havahLogo from "asset/image/external/hava_logo.png";
import palaLogo from "asset/image/external/pala_logo.png";
import altavaLogo from "asset/image/external/altava_logo.png";
import hyperLogo from "asset/image/external/hyper_logo.png";

import havaSoldOut from "asset/image/soldout/hava_soldout.png";
import palaSoldOut from "asset/image/soldout/pala_soldout.png";
import altavaSoldOut from "asset/image/soldout/altava_soldout.png";
import hyperSoldOut from "asset/image/soldout/hyper_soldout.png";

import altavaDelay from "asset/image/external/altava_delay.png";
import palaClosed from "asset/image/external/closed_pala.png";
import hyperClosed from "asset/image/external/closed_hyper.png";

import soldOut from "asset/image/sold_out.png";
import closed from "asset/image/closed_all.png";

import i18n from "../../lang/i18n";
import {useSelector} from "react-redux";
import {EXTERNAL_MARKET_URIS} from "../../config/config";

function MainPage(props) {
    /* 메인 중앙 부분 */
    const { title, day, hour, min, sec, saleStart, exMarketSoldOut, saleStatus, isRevealTime } = props;

    const [havah,setHavah] = useState(havahLogo);
    const [pala,setPala] = useState(palaLogo);
    const [altava,setAltava] = useState(altavaLogo);
    const [hyper,setHyper] = useState(hyperLogo);

    const [perplayInfo, setPerplayInfo] = useState(perplayInfoEn);
    const isSoldOut = useSelector(state => state.saleSlice.soldOut);
    const nftBalance = useSelector(state => state.saleSlice.totalAmount);
    const scheduleKind = useSelector(state => state.saleSlice.saleId);

    useEffect(()=>{
        if(isRevealTime){
            if(i18n.language === "en-US"){
                setPerplayInfo(perplayRevealInfoEn);
            }else if(i18n.language === "ko-KR"){
                setPerplayInfo(perplayRevealInfoKo);
            }

        }
    },[isRevealTime]);

    useEffect(()=>{
        //console.log("SoldOut :", isSoldOut);
    },[isSoldOut]);

    useEffect(()=>{
        //console.log("total amount : ",nftBalance);
    },[nftBalance]);

    useEffect(()=>{
        console.log(exMarketSoldOut["Pala"]);
        if(exMarketSoldOut["Havah"]){
            setHavah(havaSoldOut);
        }else{
            setHavah(havahLogo);
        }

        if(exMarketSoldOut["Pala"] === null || exMarketSoldOut["Pala"] === undefined){
            setPala(palaClosed);
        }else{
            if(exMarketSoldOut["Pala"]){
                setPala(palaSoldOut);
            }else{
                setPala(palaLogo);
            }
        }


        if(exMarketSoldOut["Altava"]){
            setAltava(altavaSoldOut);
        }else{
            setAltava(altavaLogo);
        }

        if(exMarketSoldOut["Hyper"] === null || exMarketSoldOut["Hyper"] === undefined){
            setHyper(hyperClosed);
        }else{
            if(exMarketSoldOut["Hyper"]){
                setHyper(hyperSoldOut);
            }else{
                setHyper(hyperLogo);
            }
        }

    },[exMarketSoldOut]);

    useEffect(()=>{
        if(i18n.language === "en-US"){
            setPerplayInfo(perplayInfoEn);
            if(isRevealTime){
                setPerplayInfo(perplayRevealInfoEn);
            }
            document.querySelector(".perplay-info-wrap").classList.add("en");
            document.querySelector(".perplay-info-wrap").classList.remove("ko");
        }else if(i18n.language === "ko-KR"){
            setPerplayInfo(perplayInfoKo);
            if(isRevealTime){
                setPerplayInfo(perplayRevealInfoKo);
            }
            document.querySelector(".perplay-info-wrap").classList.add("ko");
            document.querySelector(".perplay-info-wrap").classList.remove("en");
        }

    },[i18n.language]);

    const centerContentComponent = () => {
        let content;

        let units,tens,hundreds,thousands;

        if(nftBalance !== undefined){
            let balanceStr = nftBalance.toString();

            switch(balanceStr.length){
                case 4:
                    units = balanceStr.charAt(3);
                    tens = balanceStr.charAt(2);
                    hundreds = balanceStr.charAt(1);
                    thousands = balanceStr.charAt(0);
                    break;
                case 3:
                    units = balanceStr.charAt(2);
                    tens = balanceStr.charAt(1);
                    hundreds = balanceStr.charAt(0);
                    thousands = 0;
                    break;
                case 2:
                    units = balanceStr.charAt(1);
                    tens = balanceStr.charAt(0);
                    hundreds = 0;
                    thousands = 0;
                    break;
                case 1:
                    units = balanceStr.charAt(0);
                    tens = 0;
                    hundreds = 0;
                    thousands = 0;
                    break;
                default:
                    break;
            }

        }
        if(isRevealTime){
            content = (<>
                <img className={"center-content-soldOut"} src={closed} alt={"closed"}/>
            </>);
        }else{
            if(isSoldOut){
                content = (<>
                    <img className={"center-content-soldOut"} src={soldOut} alt={"SoldOut"}/>
                </>);
            }else{
                if(scheduleKind === saleStatus.saleId["PUBLIC"]){
                    content = ( <>
                        <div className={"center-content public"}>
                            <h4 className={"center-content-title public"}>GENESIS NFTs AVAILABLE</h4>
                            <h5 className={"center-content-subtext public"}>The public sale is now available to all, get ready to mint your <span>GENESIS NFTs</span> now.</h5>
                            <div className={"center-content-timer-wrap"}>
                                <div className={"center-content-timer"}>
                                    <div className={"timer-box"}>
                                        <div className={"timer-time"}>{thousands}</div>
                                    </div>
                                </div>
                                <div className={"center-content-timer"}>
                                    <div className={"timer-box"}>
                                        <div className={"timer-time"}>{hundreds}</div>
                                    </div>
                                </div>
                                <div className={"center-content-timer"}>
                                    <div className={"timer-box"}>
                                        <div className={"timer-time"}>{tens}</div>
                                    </div>
                                </div>
                                <div className={"center-content-timer"}>
                                    <div className={"timer-box"}>
                                        <div className={"timer-time"}>{units}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>);
                }else{
                    if(scheduleKind === saleStatus.saleId["WL"]){
                        content = (<>
                            <div className={"center-content"}>
                                <h4 className={"center-content-title"}>{title}</h4>
                                <div className={"center-content-timer-wrap"}>
                                    <div className={"center-content-timer"}>
                                        <div className={"timer-box"}>
                                            <div className={"timer-time"}>{thousands}</div>
                                        </div>
                                    </div>
                                    <div className={"center-content-timer"}>
                                        <div className={"timer-box"}>
                                            <div className={"timer-time"}>{hundreds}</div>
                                        </div>
                                    </div>
                                    <div className={"center-content-timer"}>
                                        <div className={"timer-box"}>
                                            <div className={"timer-time"}>{tens}</div>
                                        </div>
                                    </div>
                                    <div className={"center-content-timer"}>
                                        <div className={"timer-box"}>
                                            <div className={"timer-time"}>{units}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>);
                    }else{
                        content = (<>
                            <div className={"center-content"}>
                                <h4 className={"center-content-title"}>{title}</h4>
                                <div className={"center-content-timer-wrap"}>
                                    <div className={"center-content-timer-day timer-box"}>
                                        <div className={"timer-time"}>{day}</div>
                                        <div className={"timer-format"}>Days</div>
                                    </div>
                                    <div className={"center-content-timer"}>
                                        <div className={"timer-box"}>
                                            <div className={"timer-time"}>{hour}</div>
                                            <div className={"timer-format"}>Hours</div>
                                        </div>
                                        <div className={"timer-box"}>
                                            <div className={"timer-time"}>{min}</div>
                                            <div className={"timer-format"}>Min</div>
                                        </div>
                                        <div className={"timer-box"}>
                                            <div className={"timer-time"}>{sec}</div>
                                            <div className={"timer-format"}>Sec</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>);
                    }
                }

            }
        }

        return (
            <>
                {content}
            </>
              )
    }

    const moveMarket = (kind) => {
        let url = "";
        switch (kind){
            case 'havah':
                url = EXTERNAL_MARKET_URIS.HAVAH;
                break;
            case 'pala':
                url = EXTERNAL_MARKET_URIS.PALA;
                break;
            case 'altava':
                url = EXTERNAL_MARKET_URIS.ALTAVA;
                break;
            case 'hyper':
                url = EXTERNAL_MARKET_URIS.HYPER;
                break;
            default:
                return;
        }
        window.location.href=url;
    }

    function perplayInfoShow() {
        if(saleStart === "" || isRevealTime){
            return (
                <div className={"perplay-info-wrap"}>
                    <img className={"perplay-info-img"} src={perplayInfo} alt={"perplayInfo"}/>
                </div>
            );
        }else {
            return (
                <div className={"perplay-info-wrap " + saleStart}>
                    <img className={"perplay-info-img"} src={perplayInfo} alt={"perplayInfo"}/>
                </div>
            );
        }
    }

    /* 메인 중앙 부분 */
    return (
        <div className={"main-page"}>
            {/*<div className={"temp-div"}>*/}
            {/*        문국ㄱㄱㄱㄱㄱㄱㄱㄱㄱㄱㄱㄱㄱㄱㄱㄱㄱㄱㄱ*/}
            {/*</div>*/}
            <div className={"slider-area"}>
                <video
                    className={"background-image"}
                    autoPlay={true}
                    muted={true}
                    loop={true}
                    playsInline={true}
                    preload={"metadata"}
                >
                    <source src={backgroundImage} type={"video/mp4"}/>
                </video>
                <div className={"center-container"}>
                    {centerContentComponent()}
                </div>
            </div>

            {perplayInfoShow()}

            <div className={"external-wrap"}>
                <img className={"external-market-title"} src={externalTitle} alt={"market-title"}/>
                <div className={"external-market-logo-wrap"}>
                    <img className={"external-market-logo"} src={havah} alt={"havah"} onClick={()=>{moveMarket('havah')}} />
                    <div className={"external-market-divider"}></div>
                    <img className={"external-market-logo"} src={pala} alt={"pala"} onClick={()=>{moveMarket('pala')}}/>
                    <div className={"external-market-divider"}></div>
                    <img className={"external-market-logo"} src={altava} alt={"altava"} onClick={()=>{moveMarket('altava')}}/>
                    <div className={"external-market-divider"}></div>
                    <img className={"external-market-logo"} src={hyper} alt={"hyper"} onClick={()=>{moveMarket('hyper')}}/>
                </div>
            </div>
        </div>
    )
}

export default MainPage;